import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography, Avatar} from 'views/components';
import {useNavigate} from 'views/module';

const CaregiverRow = (props) => {
  const navigate = useNavigate();

  const {user} = props;

  const handleClick = (e) => {
    const url = `/caregiver/${user.caregiverRn}`;
    if (e.ctrlKey || e.metaKey) {
      // Open in a new tab
      window.open(url, '_blank');
    } else {
      // Regular navigation
      navigate(url);
    }
  };

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      px={1.5}
      py={1}
      onClick={handleClick}
      sx={{cursor: 'pointer'}}
    >
      <Avatar
        alt={user.caregiverName}
        src={user.profileImg}
      />
      <Typography fontWeight={600} variant="subtitle1">{user.caregiverName}</Typography>
    </Stack>
  );
};

CaregiverRow.propTypes = {
  user: PropTypes.shape({
    caregiverRn: PropTypes.string.isRequired,
    caregiverName: PropTypes.string.isRequired,
    profileImg: PropTypes.string,
  }).isRequired,
};

export default CaregiverRow;
